module.exports = __webpack_public_path__ + "img/beach-work.92201d81.jpg";